<!-- MOLECULE: ValidationExtension.vue -->
<!-- App-bar extension that renders the validation explorer toolbar when on small screens. -->

<script setup lang="ts">
//
// Imports
//

// Components
import ExplorerToolbar from "../../../pages/validation/molecules/ExplorerToolbar.vue";

//
// Composables
//
const { explorerProps } = useValidationPage();
</script>

<template>
  <!-- Toolbar -->
  <ExplorerToolbar v-bind="explorerProps" />
</template>
